import { reports } from "./reports";
import UserIcon from "../../../components/Common/SvgIcons/ReportIcons/UserIcon";
import ClassIcon from "../../../components/Common/SvgIcons/ReportIcons/ClassIcon";
import { FormattedMessage } from "react-intl";

export const graphicalReport = {
  label: <FormattedMessage id="REPORT_GRAPHICALRPT_TEXT" />,
  path: (tenantName) => `/${tenantName}/reports/graphicalReport`,
  buttons: (navigate, tenantName) => [
    {
      key: 1,
      label: "User Level Report",
      path: `${graphicalReport.path(tenantName)}/userGraphicalReport`,
      icon: UserIcon,
      onClick: () =>
        navigate(`${graphicalReport.path(tenantName)}/userGraphicalReport`),
    },
    {
      key: 2,
      label: "Class Level Report",
      path: `${graphicalReport.path(tenantName)}/classGraphicalReport`,
      icon: ClassIcon,
      onClick: () =>
        navigate(`${graphicalReport.path(tenantName)}/classGraphicalReport`),
    },
  ],
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="REPORT_GRAPHICALRPT_TEXT" />,
      path: `${reports.path}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
};
